import { Modal, ModalWidth } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import useFetchSnippet from '../../../../hooks/snippets/useFetchSnippet';
import { SnippetType } from '../../../../models';
import { useGlobalModalContext } from '../../../GlobalModal';
import styles from './CSViewModal.module.scss';

const cx = classNames.bind(styles);

const CSViewModal = (): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();
  const { isLoading, data } = useFetchSnippet(SnippetType.BOILER_PLATE, 'recommendationToolTipCSNP');

  return (
    <Modal
      width={ModalWidth.Medium}
      open
      onClose={closeModal}
      headerTitle="CS View"
      dataTestId="cs-view-modal"
      isLoading={isLoading}
    >
      <div className={cx('body')}>
        {!isLoading && data && (
          <div className={cx('snippet-content')} dangerouslySetInnerHTML={{ __html: data.body }} />
        )}
      </div>
    </Modal>
  );
};

export default CSViewModal;
